/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardSettingsIndexRouteImport } from './routes/dashboard/settings/index'
import { Route as DashboardIntegrationTypesIndexRouteImport } from './routes/dashboard/integration-types/index'
import { Route as DashboardClientsIndexRouteImport } from './routes/dashboard/clients/index'
import { Route as DashboardAuditLogsIndexRouteImport } from './routes/dashboard/audit-logs/index'
import { Route as DashboardAgentBlueprintsIndexRouteImport } from './routes/dashboard/agent-blueprints/index'
import { Route as DashboardIntegrationTypesNewRouteImport } from './routes/dashboard/integration-types/new'
import { Route as DashboardClientsNewRouteImport } from './routes/dashboard/clients/new'
import { Route as DashboardClientsIdRouteImport } from './routes/dashboard/clients/$id'
import { Route as DashboardAgentBlueprintsNewRouteImport } from './routes/dashboard/agent-blueprints/new'
import { Route as DashboardSettingsVoicesIndexRouteImport } from './routes/dashboard/settings/voices/index'
import { Route as DashboardSettingsTranscriptionProvidersIndexRouteImport } from './routes/dashboard/settings/transcriptionProviders/index'
import { Route as DashboardSettingsProvidersIndexRouteImport } from './routes/dashboard/settings/providers/index'
import { Route as DashboardSettingsModelsIndexRouteImport } from './routes/dashboard/settings/models/index'
import { Route as DashboardSettingsLanguagesIndexRouteImport } from './routes/dashboard/settings/languages/index'
import { Route as DashboardSettingsAgentTypesIndexRouteImport } from './routes/dashboard/settings/agentTypes/index'
import { Route as DashboardIntegrationTypesIdIndexRouteImport } from './routes/dashboard/integration-types/$id/index'
import { Route as DashboardAgentBlueprintsIdIndexRouteImport } from './routes/dashboard/agent-blueprints/$id/index'
import { Route as DashboardSettingsVoicesNewRouteImport } from './routes/dashboard/settings/voices/new'
import { Route as DashboardSettingsTranscriptionProvidersNewRouteImport } from './routes/dashboard/settings/transcriptionProviders/new'
import { Route as DashboardSettingsProvidersNewRouteImport } from './routes/dashboard/settings/providers/new'
import { Route as DashboardSettingsModelsNewRouteImport } from './routes/dashboard/settings/models/new'
import { Route as DashboardSettingsLanguagesNewRouteImport } from './routes/dashboard/settings/languages/new'
import { Route as DashboardSettingsAgentTypesNewRouteImport } from './routes/dashboard/settings/agentTypes/new'
import { Route as DashboardSettingsVoicesIdIndexRouteImport } from './routes/dashboard/settings/voices/$id/index'
import { Route as DashboardSettingsTranscriptionProvidersIdIndexRouteImport } from './routes/dashboard/settings/transcriptionProviders/$id/index'
import { Route as DashboardSettingsProvidersIdIndexRouteImport } from './routes/dashboard/settings/providers/$id/index'
import { Route as DashboardSettingsModelsIdIndexRouteImport } from './routes/dashboard/settings/models/$id/index'
import { Route as DashboardSettingsLanguagesIdIndexRouteImport } from './routes/dashboard/settings/languages/$id/index'
import { Route as DashboardSettingsAgentTypesIdIndexRouteImport } from './routes/dashboard/settings/agentTypes/$id/index'
import { Route as DashboardClientsIdSettingsIndexRouteImport } from './routes/dashboard/clients/$id/settings/index'
import { Route as DashboardClientsIdUsersNewRouteImport } from './routes/dashboard/clients/$id/users/new'
import { Route as DashboardClientsIdUsersUserIdRouteImport } from './routes/dashboard/clients/$id/users/$userId'
import { Route as DashboardClientsIdIntegrationsNewRouteImport } from './routes/dashboard/clients/$id/integrations/new'
import { Route as DashboardClientsIdAgentsNewRouteImport } from './routes/dashboard/clients/$id/agents/new'
import { Route as DashboardClientsIdAgentsAgentIdRouteImport } from './routes/dashboard/clients/$id/agents/$agentId'
import { Route as DashboardClientsIdIntegrationsIntegrationIdIndexRouteImport } from './routes/dashboard/clients/$id/integrations/$integrationId/index'
import { Route as DashboardClientsIdIntegrationsIntegrationIdCampaignsRouteImport } from './routes/dashboard/clients/$id/integrations/$integrationId/campaigns'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSettingsIndexRoute = DashboardSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardIntegrationTypesIndexRoute =
  DashboardIntegrationTypesIndexRouteImport.update({
    id: '/integration-types/',
    path: '/integration-types/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardClientsIndexRoute = DashboardClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAuditLogsIndexRoute = DashboardAuditLogsIndexRouteImport.update({
  id: '/audit-logs/',
  path: '/audit-logs/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAgentBlueprintsIndexRoute =
  DashboardAgentBlueprintsIndexRouteImport.update({
    id: '/agent-blueprints/',
    path: '/agent-blueprints/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardIntegrationTypesNewRoute =
  DashboardIntegrationTypesNewRouteImport.update({
    id: '/integration-types/new',
    path: '/integration-types/new',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardClientsNewRoute = DashboardClientsNewRouteImport.update({
  id: '/clients/new',
  path: '/clients/new',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardClientsIdRoute = DashboardClientsIdRouteImport.update({
  id: '/clients/$id',
  path: '/clients/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAgentBlueprintsNewRoute =
  DashboardAgentBlueprintsNewRouteImport.update({
    id: '/agent-blueprints/new',
    path: '/agent-blueprints/new',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsVoicesIndexRoute =
  DashboardSettingsVoicesIndexRouteImport.update({
    id: '/settings/voices/',
    path: '/settings/voices/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsTranscriptionProvidersIndexRoute =
  DashboardSettingsTranscriptionProvidersIndexRouteImport.update({
    id: '/settings/transcriptionProviders/',
    path: '/settings/transcriptionProviders/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsProvidersIndexRoute =
  DashboardSettingsProvidersIndexRouteImport.update({
    id: '/settings/providers/',
    path: '/settings/providers/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsModelsIndexRoute =
  DashboardSettingsModelsIndexRouteImport.update({
    id: '/settings/models/',
    path: '/settings/models/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsLanguagesIndexRoute =
  DashboardSettingsLanguagesIndexRouteImport.update({
    id: '/settings/languages/',
    path: '/settings/languages/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsAgentTypesIndexRoute =
  DashboardSettingsAgentTypesIndexRouteImport.update({
    id: '/settings/agentTypes/',
    path: '/settings/agentTypes/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardIntegrationTypesIdIndexRoute =
  DashboardIntegrationTypesIdIndexRouteImport.update({
    id: '/integration-types/$id/',
    path: '/integration-types/$id/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAgentBlueprintsIdIndexRoute =
  DashboardAgentBlueprintsIdIndexRouteImport.update({
    id: '/agent-blueprints/$id/',
    path: '/agent-blueprints/$id/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsVoicesNewRoute =
  DashboardSettingsVoicesNewRouteImport.update({
    id: '/settings/voices/new',
    path: '/settings/voices/new',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsTranscriptionProvidersNewRoute =
  DashboardSettingsTranscriptionProvidersNewRouteImport.update({
    id: '/settings/transcriptionProviders/new',
    path: '/settings/transcriptionProviders/new',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsProvidersNewRoute =
  DashboardSettingsProvidersNewRouteImport.update({
    id: '/settings/providers/new',
    path: '/settings/providers/new',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsModelsNewRoute =
  DashboardSettingsModelsNewRouteImport.update({
    id: '/settings/models/new',
    path: '/settings/models/new',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsLanguagesNewRoute =
  DashboardSettingsLanguagesNewRouteImport.update({
    id: '/settings/languages/new',
    path: '/settings/languages/new',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsAgentTypesNewRoute =
  DashboardSettingsAgentTypesNewRouteImport.update({
    id: '/settings/agentTypes/new',
    path: '/settings/agentTypes/new',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsVoicesIdIndexRoute =
  DashboardSettingsVoicesIdIndexRouteImport.update({
    id: '/settings/voices/$id/',
    path: '/settings/voices/$id/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsTranscriptionProvidersIdIndexRoute =
  DashboardSettingsTranscriptionProvidersIdIndexRouteImport.update({
    id: '/settings/transcriptionProviders/$id/',
    path: '/settings/transcriptionProviders/$id/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsProvidersIdIndexRoute =
  DashboardSettingsProvidersIdIndexRouteImport.update({
    id: '/settings/providers/$id/',
    path: '/settings/providers/$id/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsModelsIdIndexRoute =
  DashboardSettingsModelsIdIndexRouteImport.update({
    id: '/settings/models/$id/',
    path: '/settings/models/$id/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsLanguagesIdIndexRoute =
  DashboardSettingsLanguagesIdIndexRouteImport.update({
    id: '/settings/languages/$id/',
    path: '/settings/languages/$id/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSettingsAgentTypesIdIndexRoute =
  DashboardSettingsAgentTypesIdIndexRouteImport.update({
    id: '/settings/agentTypes/$id/',
    path: '/settings/agentTypes/$id/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardClientsIdSettingsIndexRoute =
  DashboardClientsIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => DashboardClientsIdRoute,
  } as any)
const DashboardClientsIdUsersNewRoute =
  DashboardClientsIdUsersNewRouteImport.update({
    id: '/users/new',
    path: '/users/new',
    getParentRoute: () => DashboardClientsIdRoute,
  } as any)
const DashboardClientsIdUsersUserIdRoute =
  DashboardClientsIdUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => DashboardClientsIdRoute,
  } as any)
const DashboardClientsIdIntegrationsNewRoute =
  DashboardClientsIdIntegrationsNewRouteImport.update({
    id: '/integrations/new',
    path: '/integrations/new',
    getParentRoute: () => DashboardClientsIdRoute,
  } as any)
const DashboardClientsIdAgentsNewRoute =
  DashboardClientsIdAgentsNewRouteImport.update({
    id: '/agents/new',
    path: '/agents/new',
    getParentRoute: () => DashboardClientsIdRoute,
  } as any)
const DashboardClientsIdAgentsAgentIdRoute =
  DashboardClientsIdAgentsAgentIdRouteImport.update({
    id: '/agents/$agentId',
    path: '/agents/$agentId',
    getParentRoute: () => DashboardClientsIdRoute,
  } as any)
const DashboardClientsIdIntegrationsIntegrationIdIndexRoute =
  DashboardClientsIdIntegrationsIntegrationIdIndexRouteImport.update({
    id: '/integrations/$integrationId/',
    path: '/integrations/$integrationId/',
    getParentRoute: () => DashboardClientsIdRoute,
  } as any)
const DashboardClientsIdIntegrationsIntegrationIdCampaignsRoute =
  DashboardClientsIdIntegrationsIntegrationIdCampaignsRouteImport.update({
    id: '/integrations/$integrationId/campaigns',
    path: '/integrations/$integrationId/campaigns',
    getParentRoute: () => DashboardClientsIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/agent-blueprints/new': typeof DashboardAgentBlueprintsNewRoute
  '/dashboard/clients/$id': typeof DashboardClientsIdRouteWithChildren
  '/dashboard/clients/new': typeof DashboardClientsNewRoute
  '/dashboard/integration-types/new': typeof DashboardIntegrationTypesNewRoute
  '/dashboard/agent-blueprints': typeof DashboardAgentBlueprintsIndexRoute
  '/dashboard/audit-logs': typeof DashboardAuditLogsIndexRoute
  '/dashboard/clients': typeof DashboardClientsIndexRoute
  '/dashboard/integration-types': typeof DashboardIntegrationTypesIndexRoute
  '/dashboard/settings': typeof DashboardSettingsIndexRoute
  '/dashboard/settings/agentTypes/new': typeof DashboardSettingsAgentTypesNewRoute
  '/dashboard/settings/languages/new': typeof DashboardSettingsLanguagesNewRoute
  '/dashboard/settings/models/new': typeof DashboardSettingsModelsNewRoute
  '/dashboard/settings/providers/new': typeof DashboardSettingsProvidersNewRoute
  '/dashboard/settings/transcriptionProviders/new': typeof DashboardSettingsTranscriptionProvidersNewRoute
  '/dashboard/settings/voices/new': typeof DashboardSettingsVoicesNewRoute
  '/dashboard/agent-blueprints/$id': typeof DashboardAgentBlueprintsIdIndexRoute
  '/dashboard/integration-types/$id': typeof DashboardIntegrationTypesIdIndexRoute
  '/dashboard/settings/agentTypes': typeof DashboardSettingsAgentTypesIndexRoute
  '/dashboard/settings/languages': typeof DashboardSettingsLanguagesIndexRoute
  '/dashboard/settings/models': typeof DashboardSettingsModelsIndexRoute
  '/dashboard/settings/providers': typeof DashboardSettingsProvidersIndexRoute
  '/dashboard/settings/transcriptionProviders': typeof DashboardSettingsTranscriptionProvidersIndexRoute
  '/dashboard/settings/voices': typeof DashboardSettingsVoicesIndexRoute
  '/dashboard/clients/$id/agents/$agentId': typeof DashboardClientsIdAgentsAgentIdRoute
  '/dashboard/clients/$id/agents/new': typeof DashboardClientsIdAgentsNewRoute
  '/dashboard/clients/$id/integrations/new': typeof DashboardClientsIdIntegrationsNewRoute
  '/dashboard/clients/$id/users/$userId': typeof DashboardClientsIdUsersUserIdRoute
  '/dashboard/clients/$id/users/new': typeof DashboardClientsIdUsersNewRoute
  '/dashboard/clients/$id/settings': typeof DashboardClientsIdSettingsIndexRoute
  '/dashboard/settings/agentTypes/$id': typeof DashboardSettingsAgentTypesIdIndexRoute
  '/dashboard/settings/languages/$id': typeof DashboardSettingsLanguagesIdIndexRoute
  '/dashboard/settings/models/$id': typeof DashboardSettingsModelsIdIndexRoute
  '/dashboard/settings/providers/$id': typeof DashboardSettingsProvidersIdIndexRoute
  '/dashboard/settings/transcriptionProviders/$id': typeof DashboardSettingsTranscriptionProvidersIdIndexRoute
  '/dashboard/settings/voices/$id': typeof DashboardSettingsVoicesIdIndexRoute
  '/dashboard/clients/$id/integrations/$integrationId/campaigns': typeof DashboardClientsIdIntegrationsIntegrationIdCampaignsRoute
  '/dashboard/clients/$id/integrations/$integrationId': typeof DashboardClientsIdIntegrationsIntegrationIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/agent-blueprints/new': typeof DashboardAgentBlueprintsNewRoute
  '/dashboard/clients/$id': typeof DashboardClientsIdRouteWithChildren
  '/dashboard/clients/new': typeof DashboardClientsNewRoute
  '/dashboard/integration-types/new': typeof DashboardIntegrationTypesNewRoute
  '/dashboard/agent-blueprints': typeof DashboardAgentBlueprintsIndexRoute
  '/dashboard/audit-logs': typeof DashboardAuditLogsIndexRoute
  '/dashboard/clients': typeof DashboardClientsIndexRoute
  '/dashboard/integration-types': typeof DashboardIntegrationTypesIndexRoute
  '/dashboard/settings': typeof DashboardSettingsIndexRoute
  '/dashboard/settings/agentTypes/new': typeof DashboardSettingsAgentTypesNewRoute
  '/dashboard/settings/languages/new': typeof DashboardSettingsLanguagesNewRoute
  '/dashboard/settings/models/new': typeof DashboardSettingsModelsNewRoute
  '/dashboard/settings/providers/new': typeof DashboardSettingsProvidersNewRoute
  '/dashboard/settings/transcriptionProviders/new': typeof DashboardSettingsTranscriptionProvidersNewRoute
  '/dashboard/settings/voices/new': typeof DashboardSettingsVoicesNewRoute
  '/dashboard/agent-blueprints/$id': typeof DashboardAgentBlueprintsIdIndexRoute
  '/dashboard/integration-types/$id': typeof DashboardIntegrationTypesIdIndexRoute
  '/dashboard/settings/agentTypes': typeof DashboardSettingsAgentTypesIndexRoute
  '/dashboard/settings/languages': typeof DashboardSettingsLanguagesIndexRoute
  '/dashboard/settings/models': typeof DashboardSettingsModelsIndexRoute
  '/dashboard/settings/providers': typeof DashboardSettingsProvidersIndexRoute
  '/dashboard/settings/transcriptionProviders': typeof DashboardSettingsTranscriptionProvidersIndexRoute
  '/dashboard/settings/voices': typeof DashboardSettingsVoicesIndexRoute
  '/dashboard/clients/$id/agents/$agentId': typeof DashboardClientsIdAgentsAgentIdRoute
  '/dashboard/clients/$id/agents/new': typeof DashboardClientsIdAgentsNewRoute
  '/dashboard/clients/$id/integrations/new': typeof DashboardClientsIdIntegrationsNewRoute
  '/dashboard/clients/$id/users/$userId': typeof DashboardClientsIdUsersUserIdRoute
  '/dashboard/clients/$id/users/new': typeof DashboardClientsIdUsersNewRoute
  '/dashboard/clients/$id/settings': typeof DashboardClientsIdSettingsIndexRoute
  '/dashboard/settings/agentTypes/$id': typeof DashboardSettingsAgentTypesIdIndexRoute
  '/dashboard/settings/languages/$id': typeof DashboardSettingsLanguagesIdIndexRoute
  '/dashboard/settings/models/$id': typeof DashboardSettingsModelsIdIndexRoute
  '/dashboard/settings/providers/$id': typeof DashboardSettingsProvidersIdIndexRoute
  '/dashboard/settings/transcriptionProviders/$id': typeof DashboardSettingsTranscriptionProvidersIdIndexRoute
  '/dashboard/settings/voices/$id': typeof DashboardSettingsVoicesIdIndexRoute
  '/dashboard/clients/$id/integrations/$integrationId/campaigns': typeof DashboardClientsIdIntegrationsIntegrationIdCampaignsRoute
  '/dashboard/clients/$id/integrations/$integrationId': typeof DashboardClientsIdIntegrationsIntegrationIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/agent-blueprints/new': typeof DashboardAgentBlueprintsNewRoute
  '/dashboard/clients/$id': typeof DashboardClientsIdRouteWithChildren
  '/dashboard/clients/new': typeof DashboardClientsNewRoute
  '/dashboard/integration-types/new': typeof DashboardIntegrationTypesNewRoute
  '/dashboard/agent-blueprints/': typeof DashboardAgentBlueprintsIndexRoute
  '/dashboard/audit-logs/': typeof DashboardAuditLogsIndexRoute
  '/dashboard/clients/': typeof DashboardClientsIndexRoute
  '/dashboard/integration-types/': typeof DashboardIntegrationTypesIndexRoute
  '/dashboard/settings/': typeof DashboardSettingsIndexRoute
  '/dashboard/settings/agentTypes/new': typeof DashboardSettingsAgentTypesNewRoute
  '/dashboard/settings/languages/new': typeof DashboardSettingsLanguagesNewRoute
  '/dashboard/settings/models/new': typeof DashboardSettingsModelsNewRoute
  '/dashboard/settings/providers/new': typeof DashboardSettingsProvidersNewRoute
  '/dashboard/settings/transcriptionProviders/new': typeof DashboardSettingsTranscriptionProvidersNewRoute
  '/dashboard/settings/voices/new': typeof DashboardSettingsVoicesNewRoute
  '/dashboard/agent-blueprints/$id/': typeof DashboardAgentBlueprintsIdIndexRoute
  '/dashboard/integration-types/$id/': typeof DashboardIntegrationTypesIdIndexRoute
  '/dashboard/settings/agentTypes/': typeof DashboardSettingsAgentTypesIndexRoute
  '/dashboard/settings/languages/': typeof DashboardSettingsLanguagesIndexRoute
  '/dashboard/settings/models/': typeof DashboardSettingsModelsIndexRoute
  '/dashboard/settings/providers/': typeof DashboardSettingsProvidersIndexRoute
  '/dashboard/settings/transcriptionProviders/': typeof DashboardSettingsTranscriptionProvidersIndexRoute
  '/dashboard/settings/voices/': typeof DashboardSettingsVoicesIndexRoute
  '/dashboard/clients/$id/agents/$agentId': typeof DashboardClientsIdAgentsAgentIdRoute
  '/dashboard/clients/$id/agents/new': typeof DashboardClientsIdAgentsNewRoute
  '/dashboard/clients/$id/integrations/new': typeof DashboardClientsIdIntegrationsNewRoute
  '/dashboard/clients/$id/users/$userId': typeof DashboardClientsIdUsersUserIdRoute
  '/dashboard/clients/$id/users/new': typeof DashboardClientsIdUsersNewRoute
  '/dashboard/clients/$id/settings/': typeof DashboardClientsIdSettingsIndexRoute
  '/dashboard/settings/agentTypes/$id/': typeof DashboardSettingsAgentTypesIdIndexRoute
  '/dashboard/settings/languages/$id/': typeof DashboardSettingsLanguagesIdIndexRoute
  '/dashboard/settings/models/$id/': typeof DashboardSettingsModelsIdIndexRoute
  '/dashboard/settings/providers/$id/': typeof DashboardSettingsProvidersIdIndexRoute
  '/dashboard/settings/transcriptionProviders/$id/': typeof DashboardSettingsTranscriptionProvidersIdIndexRoute
  '/dashboard/settings/voices/$id/': typeof DashboardSettingsVoicesIdIndexRoute
  '/dashboard/clients/$id/integrations/$integrationId/campaigns': typeof DashboardClientsIdIntegrationsIntegrationIdCampaignsRoute
  '/dashboard/clients/$id/integrations/$integrationId/': typeof DashboardClientsIdIntegrationsIntegrationIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/unauthorized'
    | '/dashboard/'
    | '/dashboard/agent-blueprints/new'
    | '/dashboard/clients/$id'
    | '/dashboard/clients/new'
    | '/dashboard/integration-types/new'
    | '/dashboard/agent-blueprints'
    | '/dashboard/audit-logs'
    | '/dashboard/clients'
    | '/dashboard/integration-types'
    | '/dashboard/settings'
    | '/dashboard/settings/agentTypes/new'
    | '/dashboard/settings/languages/new'
    | '/dashboard/settings/models/new'
    | '/dashboard/settings/providers/new'
    | '/dashboard/settings/transcriptionProviders/new'
    | '/dashboard/settings/voices/new'
    | '/dashboard/agent-blueprints/$id'
    | '/dashboard/integration-types/$id'
    | '/dashboard/settings/agentTypes'
    | '/dashboard/settings/languages'
    | '/dashboard/settings/models'
    | '/dashboard/settings/providers'
    | '/dashboard/settings/transcriptionProviders'
    | '/dashboard/settings/voices'
    | '/dashboard/clients/$id/agents/$agentId'
    | '/dashboard/clients/$id/agents/new'
    | '/dashboard/clients/$id/integrations/new'
    | '/dashboard/clients/$id/users/$userId'
    | '/dashboard/clients/$id/users/new'
    | '/dashboard/clients/$id/settings'
    | '/dashboard/settings/agentTypes/$id'
    | '/dashboard/settings/languages/$id'
    | '/dashboard/settings/models/$id'
    | '/dashboard/settings/providers/$id'
    | '/dashboard/settings/transcriptionProviders/$id'
    | '/dashboard/settings/voices/$id'
    | '/dashboard/clients/$id/integrations/$integrationId/campaigns'
    | '/dashboard/clients/$id/integrations/$integrationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/unauthorized'
    | '/dashboard'
    | '/dashboard/agent-blueprints/new'
    | '/dashboard/clients/$id'
    | '/dashboard/clients/new'
    | '/dashboard/integration-types/new'
    | '/dashboard/agent-blueprints'
    | '/dashboard/audit-logs'
    | '/dashboard/clients'
    | '/dashboard/integration-types'
    | '/dashboard/settings'
    | '/dashboard/settings/agentTypes/new'
    | '/dashboard/settings/languages/new'
    | '/dashboard/settings/models/new'
    | '/dashboard/settings/providers/new'
    | '/dashboard/settings/transcriptionProviders/new'
    | '/dashboard/settings/voices/new'
    | '/dashboard/agent-blueprints/$id'
    | '/dashboard/integration-types/$id'
    | '/dashboard/settings/agentTypes'
    | '/dashboard/settings/languages'
    | '/dashboard/settings/models'
    | '/dashboard/settings/providers'
    | '/dashboard/settings/transcriptionProviders'
    | '/dashboard/settings/voices'
    | '/dashboard/clients/$id/agents/$agentId'
    | '/dashboard/clients/$id/agents/new'
    | '/dashboard/clients/$id/integrations/new'
    | '/dashboard/clients/$id/users/$userId'
    | '/dashboard/clients/$id/users/new'
    | '/dashboard/clients/$id/settings'
    | '/dashboard/settings/agentTypes/$id'
    | '/dashboard/settings/languages/$id'
    | '/dashboard/settings/models/$id'
    | '/dashboard/settings/providers/$id'
    | '/dashboard/settings/transcriptionProviders/$id'
    | '/dashboard/settings/voices/$id'
    | '/dashboard/clients/$id/integrations/$integrationId/campaigns'
    | '/dashboard/clients/$id/integrations/$integrationId'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/login'
    | '/unauthorized'
    | '/dashboard/'
    | '/dashboard/agent-blueprints/new'
    | '/dashboard/clients/$id'
    | '/dashboard/clients/new'
    | '/dashboard/integration-types/new'
    | '/dashboard/agent-blueprints/'
    | '/dashboard/audit-logs/'
    | '/dashboard/clients/'
    | '/dashboard/integration-types/'
    | '/dashboard/settings/'
    | '/dashboard/settings/agentTypes/new'
    | '/dashboard/settings/languages/new'
    | '/dashboard/settings/models/new'
    | '/dashboard/settings/providers/new'
    | '/dashboard/settings/transcriptionProviders/new'
    | '/dashboard/settings/voices/new'
    | '/dashboard/agent-blueprints/$id/'
    | '/dashboard/integration-types/$id/'
    | '/dashboard/settings/agentTypes/'
    | '/dashboard/settings/languages/'
    | '/dashboard/settings/models/'
    | '/dashboard/settings/providers/'
    | '/dashboard/settings/transcriptionProviders/'
    | '/dashboard/settings/voices/'
    | '/dashboard/clients/$id/agents/$agentId'
    | '/dashboard/clients/$id/agents/new'
    | '/dashboard/clients/$id/integrations/new'
    | '/dashboard/clients/$id/users/$userId'
    | '/dashboard/clients/$id/users/new'
    | '/dashboard/clients/$id/settings/'
    | '/dashboard/settings/agentTypes/$id/'
    | '/dashboard/settings/languages/$id/'
    | '/dashboard/settings/models/$id/'
    | '/dashboard/settings/providers/$id/'
    | '/dashboard/settings/transcriptionProviders/$id/'
    | '/dashboard/settings/voices/$id/'
    | '/dashboard/clients/$id/integrations/$integrationId/campaigns'
    | '/dashboard/clients/$id/integrations/$integrationId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/': {
      id: '/dashboard/settings/'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/integration-types/': {
      id: '/dashboard/integration-types/'
      path: '/integration-types'
      fullPath: '/dashboard/integration-types'
      preLoaderRoute: typeof DashboardIntegrationTypesIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/clients/': {
      id: '/dashboard/clients/'
      path: '/clients'
      fullPath: '/dashboard/clients'
      preLoaderRoute: typeof DashboardClientsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/audit-logs/': {
      id: '/dashboard/audit-logs/'
      path: '/audit-logs'
      fullPath: '/dashboard/audit-logs'
      preLoaderRoute: typeof DashboardAuditLogsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/agent-blueprints/': {
      id: '/dashboard/agent-blueprints/'
      path: '/agent-blueprints'
      fullPath: '/dashboard/agent-blueprints'
      preLoaderRoute: typeof DashboardAgentBlueprintsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/integration-types/new': {
      id: '/dashboard/integration-types/new'
      path: '/integration-types/new'
      fullPath: '/dashboard/integration-types/new'
      preLoaderRoute: typeof DashboardIntegrationTypesNewRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/clients/new': {
      id: '/dashboard/clients/new'
      path: '/clients/new'
      fullPath: '/dashboard/clients/new'
      preLoaderRoute: typeof DashboardClientsNewRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/clients/$id': {
      id: '/dashboard/clients/$id'
      path: '/clients/$id'
      fullPath: '/dashboard/clients/$id'
      preLoaderRoute: typeof DashboardClientsIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/agent-blueprints/new': {
      id: '/dashboard/agent-blueprints/new'
      path: '/agent-blueprints/new'
      fullPath: '/dashboard/agent-blueprints/new'
      preLoaderRoute: typeof DashboardAgentBlueprintsNewRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/voices/': {
      id: '/dashboard/settings/voices/'
      path: '/settings/voices'
      fullPath: '/dashboard/settings/voices'
      preLoaderRoute: typeof DashboardSettingsVoicesIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/transcriptionProviders/': {
      id: '/dashboard/settings/transcriptionProviders/'
      path: '/settings/transcriptionProviders'
      fullPath: '/dashboard/settings/transcriptionProviders'
      preLoaderRoute: typeof DashboardSettingsTranscriptionProvidersIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/providers/': {
      id: '/dashboard/settings/providers/'
      path: '/settings/providers'
      fullPath: '/dashboard/settings/providers'
      preLoaderRoute: typeof DashboardSettingsProvidersIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/models/': {
      id: '/dashboard/settings/models/'
      path: '/settings/models'
      fullPath: '/dashboard/settings/models'
      preLoaderRoute: typeof DashboardSettingsModelsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/languages/': {
      id: '/dashboard/settings/languages/'
      path: '/settings/languages'
      fullPath: '/dashboard/settings/languages'
      preLoaderRoute: typeof DashboardSettingsLanguagesIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/agentTypes/': {
      id: '/dashboard/settings/agentTypes/'
      path: '/settings/agentTypes'
      fullPath: '/dashboard/settings/agentTypes'
      preLoaderRoute: typeof DashboardSettingsAgentTypesIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/integration-types/$id/': {
      id: '/dashboard/integration-types/$id/'
      path: '/integration-types/$id'
      fullPath: '/dashboard/integration-types/$id'
      preLoaderRoute: typeof DashboardIntegrationTypesIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/agent-blueprints/$id/': {
      id: '/dashboard/agent-blueprints/$id/'
      path: '/agent-blueprints/$id'
      fullPath: '/dashboard/agent-blueprints/$id'
      preLoaderRoute: typeof DashboardAgentBlueprintsIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/voices/new': {
      id: '/dashboard/settings/voices/new'
      path: '/settings/voices/new'
      fullPath: '/dashboard/settings/voices/new'
      preLoaderRoute: typeof DashboardSettingsVoicesNewRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/transcriptionProviders/new': {
      id: '/dashboard/settings/transcriptionProviders/new'
      path: '/settings/transcriptionProviders/new'
      fullPath: '/dashboard/settings/transcriptionProviders/new'
      preLoaderRoute: typeof DashboardSettingsTranscriptionProvidersNewRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/providers/new': {
      id: '/dashboard/settings/providers/new'
      path: '/settings/providers/new'
      fullPath: '/dashboard/settings/providers/new'
      preLoaderRoute: typeof DashboardSettingsProvidersNewRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/models/new': {
      id: '/dashboard/settings/models/new'
      path: '/settings/models/new'
      fullPath: '/dashboard/settings/models/new'
      preLoaderRoute: typeof DashboardSettingsModelsNewRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/languages/new': {
      id: '/dashboard/settings/languages/new'
      path: '/settings/languages/new'
      fullPath: '/dashboard/settings/languages/new'
      preLoaderRoute: typeof DashboardSettingsLanguagesNewRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/agentTypes/new': {
      id: '/dashboard/settings/agentTypes/new'
      path: '/settings/agentTypes/new'
      fullPath: '/dashboard/settings/agentTypes/new'
      preLoaderRoute: typeof DashboardSettingsAgentTypesNewRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/voices/$id/': {
      id: '/dashboard/settings/voices/$id/'
      path: '/settings/voices/$id'
      fullPath: '/dashboard/settings/voices/$id'
      preLoaderRoute: typeof DashboardSettingsVoicesIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/transcriptionProviders/$id/': {
      id: '/dashboard/settings/transcriptionProviders/$id/'
      path: '/settings/transcriptionProviders/$id'
      fullPath: '/dashboard/settings/transcriptionProviders/$id'
      preLoaderRoute: typeof DashboardSettingsTranscriptionProvidersIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/providers/$id/': {
      id: '/dashboard/settings/providers/$id/'
      path: '/settings/providers/$id'
      fullPath: '/dashboard/settings/providers/$id'
      preLoaderRoute: typeof DashboardSettingsProvidersIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/models/$id/': {
      id: '/dashboard/settings/models/$id/'
      path: '/settings/models/$id'
      fullPath: '/dashboard/settings/models/$id'
      preLoaderRoute: typeof DashboardSettingsModelsIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/languages/$id/': {
      id: '/dashboard/settings/languages/$id/'
      path: '/settings/languages/$id'
      fullPath: '/dashboard/settings/languages/$id'
      preLoaderRoute: typeof DashboardSettingsLanguagesIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings/agentTypes/$id/': {
      id: '/dashboard/settings/agentTypes/$id/'
      path: '/settings/agentTypes/$id'
      fullPath: '/dashboard/settings/agentTypes/$id'
      preLoaderRoute: typeof DashboardSettingsAgentTypesIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/clients/$id/settings/': {
      id: '/dashboard/clients/$id/settings/'
      path: '/settings'
      fullPath: '/dashboard/clients/$id/settings'
      preLoaderRoute: typeof DashboardClientsIdSettingsIndexRouteImport
      parentRoute: typeof DashboardClientsIdRoute
    }
    '/dashboard/clients/$id/users/new': {
      id: '/dashboard/clients/$id/users/new'
      path: '/users/new'
      fullPath: '/dashboard/clients/$id/users/new'
      preLoaderRoute: typeof DashboardClientsIdUsersNewRouteImport
      parentRoute: typeof DashboardClientsIdRoute
    }
    '/dashboard/clients/$id/users/$userId': {
      id: '/dashboard/clients/$id/users/$userId'
      path: '/users/$userId'
      fullPath: '/dashboard/clients/$id/users/$userId'
      preLoaderRoute: typeof DashboardClientsIdUsersUserIdRouteImport
      parentRoute: typeof DashboardClientsIdRoute
    }
    '/dashboard/clients/$id/integrations/new': {
      id: '/dashboard/clients/$id/integrations/new'
      path: '/integrations/new'
      fullPath: '/dashboard/clients/$id/integrations/new'
      preLoaderRoute: typeof DashboardClientsIdIntegrationsNewRouteImport
      parentRoute: typeof DashboardClientsIdRoute
    }
    '/dashboard/clients/$id/agents/new': {
      id: '/dashboard/clients/$id/agents/new'
      path: '/agents/new'
      fullPath: '/dashboard/clients/$id/agents/new'
      preLoaderRoute: typeof DashboardClientsIdAgentsNewRouteImport
      parentRoute: typeof DashboardClientsIdRoute
    }
    '/dashboard/clients/$id/agents/$agentId': {
      id: '/dashboard/clients/$id/agents/$agentId'
      path: '/agents/$agentId'
      fullPath: '/dashboard/clients/$id/agents/$agentId'
      preLoaderRoute: typeof DashboardClientsIdAgentsAgentIdRouteImport
      parentRoute: typeof DashboardClientsIdRoute
    }
    '/dashboard/clients/$id/integrations/$integrationId/': {
      id: '/dashboard/clients/$id/integrations/$integrationId/'
      path: '/integrations/$integrationId'
      fullPath: '/dashboard/clients/$id/integrations/$integrationId'
      preLoaderRoute: typeof DashboardClientsIdIntegrationsIntegrationIdIndexRouteImport
      parentRoute: typeof DashboardClientsIdRoute
    }
    '/dashboard/clients/$id/integrations/$integrationId/campaigns': {
      id: '/dashboard/clients/$id/integrations/$integrationId/campaigns'
      path: '/integrations/$integrationId/campaigns'
      fullPath: '/dashboard/clients/$id/integrations/$integrationId/campaigns'
      preLoaderRoute: typeof DashboardClientsIdIntegrationsIntegrationIdCampaignsRouteImport
      parentRoute: typeof DashboardClientsIdRoute
    }
  }
}

interface DashboardClientsIdRouteChildren {
  DashboardClientsIdAgentsAgentIdRoute: typeof DashboardClientsIdAgentsAgentIdRoute
  DashboardClientsIdAgentsNewRoute: typeof DashboardClientsIdAgentsNewRoute
  DashboardClientsIdIntegrationsNewRoute: typeof DashboardClientsIdIntegrationsNewRoute
  DashboardClientsIdUsersUserIdRoute: typeof DashboardClientsIdUsersUserIdRoute
  DashboardClientsIdUsersNewRoute: typeof DashboardClientsIdUsersNewRoute
  DashboardClientsIdSettingsIndexRoute: typeof DashboardClientsIdSettingsIndexRoute
  DashboardClientsIdIntegrationsIntegrationIdCampaignsRoute: typeof DashboardClientsIdIntegrationsIntegrationIdCampaignsRoute
  DashboardClientsIdIntegrationsIntegrationIdIndexRoute: typeof DashboardClientsIdIntegrationsIntegrationIdIndexRoute
}

const DashboardClientsIdRouteChildren: DashboardClientsIdRouteChildren = {
  DashboardClientsIdAgentsAgentIdRoute: DashboardClientsIdAgentsAgentIdRoute,
  DashboardClientsIdAgentsNewRoute: DashboardClientsIdAgentsNewRoute,
  DashboardClientsIdIntegrationsNewRoute:
    DashboardClientsIdIntegrationsNewRoute,
  DashboardClientsIdUsersUserIdRoute: DashboardClientsIdUsersUserIdRoute,
  DashboardClientsIdUsersNewRoute: DashboardClientsIdUsersNewRoute,
  DashboardClientsIdSettingsIndexRoute: DashboardClientsIdSettingsIndexRoute,
  DashboardClientsIdIntegrationsIntegrationIdCampaignsRoute:
    DashboardClientsIdIntegrationsIntegrationIdCampaignsRoute,
  DashboardClientsIdIntegrationsIntegrationIdIndexRoute:
    DashboardClientsIdIntegrationsIntegrationIdIndexRoute,
}

const DashboardClientsIdRouteWithChildren =
  DashboardClientsIdRoute._addFileChildren(DashboardClientsIdRouteChildren)

interface DashboardRouteRouteChildren {
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardAgentBlueprintsNewRoute: typeof DashboardAgentBlueprintsNewRoute
  DashboardClientsIdRoute: typeof DashboardClientsIdRouteWithChildren
  DashboardClientsNewRoute: typeof DashboardClientsNewRoute
  DashboardIntegrationTypesNewRoute: typeof DashboardIntegrationTypesNewRoute
  DashboardAgentBlueprintsIndexRoute: typeof DashboardAgentBlueprintsIndexRoute
  DashboardAuditLogsIndexRoute: typeof DashboardAuditLogsIndexRoute
  DashboardClientsIndexRoute: typeof DashboardClientsIndexRoute
  DashboardIntegrationTypesIndexRoute: typeof DashboardIntegrationTypesIndexRoute
  DashboardSettingsIndexRoute: typeof DashboardSettingsIndexRoute
  DashboardSettingsAgentTypesNewRoute: typeof DashboardSettingsAgentTypesNewRoute
  DashboardSettingsLanguagesNewRoute: typeof DashboardSettingsLanguagesNewRoute
  DashboardSettingsModelsNewRoute: typeof DashboardSettingsModelsNewRoute
  DashboardSettingsProvidersNewRoute: typeof DashboardSettingsProvidersNewRoute
  DashboardSettingsTranscriptionProvidersNewRoute: typeof DashboardSettingsTranscriptionProvidersNewRoute
  DashboardSettingsVoicesNewRoute: typeof DashboardSettingsVoicesNewRoute
  DashboardAgentBlueprintsIdIndexRoute: typeof DashboardAgentBlueprintsIdIndexRoute
  DashboardIntegrationTypesIdIndexRoute: typeof DashboardIntegrationTypesIdIndexRoute
  DashboardSettingsAgentTypesIndexRoute: typeof DashboardSettingsAgentTypesIndexRoute
  DashboardSettingsLanguagesIndexRoute: typeof DashboardSettingsLanguagesIndexRoute
  DashboardSettingsModelsIndexRoute: typeof DashboardSettingsModelsIndexRoute
  DashboardSettingsProvidersIndexRoute: typeof DashboardSettingsProvidersIndexRoute
  DashboardSettingsTranscriptionProvidersIndexRoute: typeof DashboardSettingsTranscriptionProvidersIndexRoute
  DashboardSettingsVoicesIndexRoute: typeof DashboardSettingsVoicesIndexRoute
  DashboardSettingsAgentTypesIdIndexRoute: typeof DashboardSettingsAgentTypesIdIndexRoute
  DashboardSettingsLanguagesIdIndexRoute: typeof DashboardSettingsLanguagesIdIndexRoute
  DashboardSettingsModelsIdIndexRoute: typeof DashboardSettingsModelsIdIndexRoute
  DashboardSettingsProvidersIdIndexRoute: typeof DashboardSettingsProvidersIdIndexRoute
  DashboardSettingsTranscriptionProvidersIdIndexRoute: typeof DashboardSettingsTranscriptionProvidersIdIndexRoute
  DashboardSettingsVoicesIdIndexRoute: typeof DashboardSettingsVoicesIdIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardAgentBlueprintsNewRoute: DashboardAgentBlueprintsNewRoute,
  DashboardClientsIdRoute: DashboardClientsIdRouteWithChildren,
  DashboardClientsNewRoute: DashboardClientsNewRoute,
  DashboardIntegrationTypesNewRoute: DashboardIntegrationTypesNewRoute,
  DashboardAgentBlueprintsIndexRoute: DashboardAgentBlueprintsIndexRoute,
  DashboardAuditLogsIndexRoute: DashboardAuditLogsIndexRoute,
  DashboardClientsIndexRoute: DashboardClientsIndexRoute,
  DashboardIntegrationTypesIndexRoute: DashboardIntegrationTypesIndexRoute,
  DashboardSettingsIndexRoute: DashboardSettingsIndexRoute,
  DashboardSettingsAgentTypesNewRoute: DashboardSettingsAgentTypesNewRoute,
  DashboardSettingsLanguagesNewRoute: DashboardSettingsLanguagesNewRoute,
  DashboardSettingsModelsNewRoute: DashboardSettingsModelsNewRoute,
  DashboardSettingsProvidersNewRoute: DashboardSettingsProvidersNewRoute,
  DashboardSettingsTranscriptionProvidersNewRoute:
    DashboardSettingsTranscriptionProvidersNewRoute,
  DashboardSettingsVoicesNewRoute: DashboardSettingsVoicesNewRoute,
  DashboardAgentBlueprintsIdIndexRoute: DashboardAgentBlueprintsIdIndexRoute,
  DashboardIntegrationTypesIdIndexRoute: DashboardIntegrationTypesIdIndexRoute,
  DashboardSettingsAgentTypesIndexRoute: DashboardSettingsAgentTypesIndexRoute,
  DashboardSettingsLanguagesIndexRoute: DashboardSettingsLanguagesIndexRoute,
  DashboardSettingsModelsIndexRoute: DashboardSettingsModelsIndexRoute,
  DashboardSettingsProvidersIndexRoute: DashboardSettingsProvidersIndexRoute,
  DashboardSettingsTranscriptionProvidersIndexRoute:
    DashboardSettingsTranscriptionProvidersIndexRoute,
  DashboardSettingsVoicesIndexRoute: DashboardSettingsVoicesIndexRoute,
  DashboardSettingsAgentTypesIdIndexRoute:
    DashboardSettingsAgentTypesIdIndexRoute,
  DashboardSettingsLanguagesIdIndexRoute:
    DashboardSettingsLanguagesIdIndexRoute,
  DashboardSettingsModelsIdIndexRoute: DashboardSettingsModelsIdIndexRoute,
  DashboardSettingsProvidersIdIndexRoute:
    DashboardSettingsProvidersIdIndexRoute,
  DashboardSettingsTranscriptionProvidersIdIndexRoute:
    DashboardSettingsTranscriptionProvidersIdIndexRoute,
  DashboardSettingsVoicesIdIndexRoute: DashboardSettingsVoicesIdIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
